import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const OPUS_URL = process.env.REACT_APP_OPUS_URL || 'https://dev.opus.aelive.cloud';

const NoSessionScreen = () => {
  const handleLaunchOpus = () => {
    // Open OPUS in a new tab
    window.open(OPUS_URL, '_blank');
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        backgroundColor: 'background.default',
        color: 'text.primary',
        textAlign: 'center',
        padding: 3,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderRadius: 2,
          padding: 4,
          maxWidth: 420,
          border: '1px solid rgba(255, 255, 255, 0.12)',
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: 'text.primary',
            marginBottom: 3,
            fontWeight: 500,
          }}
        >
          No session found. Please access this application through OPUS.
        </Typography>
        
        <Button
          variant="contained"
          color="primary"
          onClick={handleLaunchOpus}
          endIcon={<OpenInNewIcon />}
        >
          Launch OPUS
        </Button>
      </Box>
    </Box>
  );
};

export default NoSessionScreen;
